export default "__VITE_ASSET__5OdOYhsy__"